import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { REACT_QUERY_SELLER_IMAGES_QUERY_KEY } from '../constants';
import sellerImageUseCase from '../factories/sellerImage';

export const useGetSellerImages = (variables, options = {}) => {
  const query = useQuery(
    [REACT_QUERY_SELLER_IMAGES_QUERY_KEY, variables],
    () => sellerImageUseCase.getSellerImages(variables),
    options
  );

  return {
    ...query,
    data: query.data || {},
  };
};

export const useCreateSellerImage = () => useMutation(sellerImageUseCase.createSellerImage);

export const useBulkCreateSellerImage = () => useMutation(sellerImageUseCase.bulkCreateSellerImage);

export const useDeleteSellerImage = (options) => {
  const queryClient = useQueryClient();

  return useMutation(async (id) => {
    await sellerImageUseCase.deleteSellerImage(id);
    queryClient.removeQueries([REACT_QUERY_SELLER_IMAGES_QUERY_KEY]);
  }, options);
};

export const useUpdateSellerImageOrdering = () => {
  const mutation = useMutation(sellerImageUseCase.updateSellerImageOrdering);
  return mutation;
};

export const useUploadImage = () => useMutation(sellerImageUseCase.uploadImage);
